import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from "ag-grid-angular";
import { EspGridLoadingParams } from "../../../components/grid-loading/grid-loading.component";

/** Imported forecasts grid loading overlay: skeleton on first load, then the spinner. */
@Component({
  standalone: false,
  selector: 'wfm-esp-imported-forecasts-loading-overlay',
  templateUrl: './imported-forecasts-loading-overlay.component.html'
})
export class ImportedForecastsLoadingOverlayComponent implements ILoadingOverlayAngularComp {
  params?: EspGridLoadingParams;

  agInit(params: EspGridLoadingParams): void {
    this.params = params;
  }
}
